import type { ClientOptions, InferRpcClient } from "@redotech/rpc/client";
import { createRpcClient } from "@redotech/rpc/client";
import { rpcDefinition } from "./definition";
export type { RedoInventoryRpcDefinition } from "./definition";

export function createRedoInventoryRpcClient(
  options: ClientOptions<typeof rpcDefinition>,
): InferRpcClient<typeof rpcDefinition> {
  return createRpcClient(rpcDefinition, options);
}

export type RedoInventoryRpcClient = ReturnType<
  typeof createRedoInventoryRpcClient
>;
